import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=0013ffd3&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=js&"
export * from "./Icons.vue?vue&type=script&lang=js&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=0013ffd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013ffd3",
  null
  
)

export default component.exports